var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}}),_c('GMS'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }